import React from 'react'

import Text from '../../Components/Text'
import Select from '../../Components/Select'

const NestedTabs = (({ tabs ,placeholder_cat, title, activeTab,onClick,children,mobileSelect, mobileSelectPlaceholder,activeOption, onChangeSelect})=>(
	<div className="container__tabs">
		<div className="tabs__header">
			{ title && title ? <Text classNames="title" text={title} /> : '' }
			{tabs && tabs.map((el)=>(
					children !== '' ?(
						<div key={el.id} data-id={el.id} className={ activeTab === el.id ? 'tab__btn active' : 'tab__btn'} onClick={onClick}>
							<div>
								<div className="title">{el.name}</div>
							</div>
						</div>
					):(
						<div key={el.id} data-id={el.id} className='tab__btn' >
							<div>
								<div className="title">{el.name}</div>
							</div>
						</div>
					)
			))}
			{
				mobileSelect && mobileSelect ? <Select options={tabs} onChange={onChangeSelect} mobileSelectPlaceholder={mobileSelectPlaceholder} placeholder={placeholder_cat} selected={activeOption} />  :''
			}
			
		</div>
		{
			children !== '' ?  <div className="content__tabs"><div className="tab"><div>{children}</div></div></div> : ''
		}
	</div>
))

export default NestedTabs;


// WEBPACK FOOTER //
// ./src/Containers/NestedTabs/index.js